import TotalPerfumeContainer from "./TotalPerfumeContainer";

export default TotalPerfumeContainer;
